<template>
  <div class="pop">
    <p class="wait" v-show="info.isWait">正在验证身份...</p>
    <div class="pop-con" v-show="!info.isBind">
      <p>您购买的产品需绑定手机号码认证之后才能提供服务，绑定后身份信息不会泄漏，还可用于找回密码。</p>
      <span @click="goBind">去绑定</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  },
  props:['info'],
  methods: {
    goBind() {
      this.$emit("close", false)
      window.open(this.info.bindUrl, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
div, p{box-sizing: border-box;}
.pop{
  width: 500px;
  height: 300px;
  background: #fff;
  border-radius: 20px;
  padding: 0px 0 20px;
  position: fixed;
  left: 50%;
  margin-left: -250px;
  top: 50%;
  margin-top: -150px;
  z-index: 2;
  border: 1px solid #0170ff;
  .wait{
    font-size: 24px;
    color: #0170ff;
    text-align: center;
    margin-top: 120px;
  }
  .pop-con{
    p{
      font-size: 24px;
      color: #000;
      line-height: 36px;
      border-bottom: 1px solid #cacaca;
      padding: 50px 28px 50px;
    }
    span{
      display: block;
      width: 180px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      font-size: 24px;
      text-align: center;
      margin: 25px auto 0;
      background: #0170ff;
      border-radius: 40px;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/BindTel.vue